import React, { useState, useEffect } from 'react';
import { Modal, Select, DatePicker, Button, Input } from 'antd';
import dayjs from 'dayjs';

const FilterModal = ({ open, onCancel, onApply, onReset, config, initialValues }) => {
  const [filterValues, setFilterValues] = useState(initialValues || {});

  useEffect(() => {
    if (open) {
      setFilterValues(initialValues || {});
    }
  }, [open, initialValues]);

  const handleChange = (key, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const handleApply = () => {
    onApply(filterValues);
  };

  const handleReset = () => {
    setFilterValues({});
    if (onReset) onReset();
  };

  return (
    <Modal
      title="Filter"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={700}
      centered
      className="filter-modal"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mt-4">
        {config.map((field) => (
          <div key={field.key} className="flex flex-col">
            <label className="text-[13px] font-medium text-slate-600 mb-1.5">{field.label}</label>
            {field.type === 'select' && (
              <Select
                className="w-full h-10 custom-select"
                placeholder={`--Select--`}
                value={filterValues[field.key]}
                onChange={(val) => handleChange(field.key, val)}
                options={field.options}
                allowClear
                showSearch={field.showSearch}
                filterOption={field.showSearch ? (input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                 : undefined}
              />
            )}
            {field.type === 'date' && (
              <DatePicker
                className="w-full h-10 custom-datepicker"
                placeholder={field.placeholder || "Select date"}
                value={filterValues[field.key] ? dayjs(filterValues[field.key]) : null}
                onChange={(date) => handleChange(field.key, date ? date.format('YYYY-MM-DD') : null)}
                format="DD-MMM-YYYY"
                disabledDate={field.key === 'toDate' && filterValues['fromDate']
                  ? (current) => current && current.isBefore(dayjs(filterValues['fromDate']), 'day')
                  : undefined}
              />
            )}
            {field.type === 'text' && (
              <Input
                className="w-full h-10 custom-input"
                placeholder={`Enter ${field.label.toLowerCase()}`}
                value={filterValues[field.key] || ''}
                onChange={(e) => handleChange(field.key, e.target.value)}
              />
            )}
          </div>
        ))}
      </div>

      <div className="flex justify-end gap-3 mt-8 pt-4 border-t border-slate-100">
        <Button onClick={onCancel} className="rounded-md h-[38px] px-5 font-medium border-slate-300 text-slate-600">Cancel</Button>
        <Button onClick={handleReset} className="rounded-md h-[38px] px-5 font-medium bg-slate-50 border-transparent text-slate-400 hover:text-slate-600 hover:bg-slate-100">Reset</Button>
        <Button onClick={handleApply} type="primary" className="rounded-md h-[38px] px-6 font-medium bg-[#0070b1] hover:bg-[#005a8e]">Apply</Button>
      </div>
    </Modal>
  );
};

export default FilterModal;
